import { StyledFlexContainer, StyledAppNumberInputWrapper } from './styles';
import AppNumberInput from 'components/FormElements/AppNumberInput';

type ShareConsideration = {
  shareholdingId: string;
  newSharesAllocated: number;
  suggestedNewSharesAllocated: number;
};

type Props = {
  cell: ShareConsideration;
  setOverride: (
    shareholdingId: string,
    data: Partial<ShareConsideration>,
  ) => void;
  disableTable: boolean;
};

const NewSharesAllocatedCell: React.FC<Props> = ({
  cell,
  setOverride,
  disableTable,
}) => {
  const isInputChanged =
    cell.newSharesAllocated !== cell.suggestedNewSharesAllocated;

  return (
    <StyledFlexContainer>
      <StyledAppNumberInputWrapper isInputChanged={isInputChanged}>
        <AppNumberInput
          disabled={disableTable}
          defaultValue={0}
          min={0}
          fullWidth
          decimals={10}
          value={cell.newSharesAllocated}
          onChange={(value) => {
            setOverride(cell.shareholdingId, {
              newSharesAllocated: Number(value),
            });
          }}
        />
      </StyledAppNumberInputWrapper>
    </StyledFlexContainer>
  );
};
export default NewSharesAllocatedCell;
